import { Injectable } from '@angular/core';
import { AuthService } from '../../base/services/auth.service';
import { AuthErrorInterceptorBase } from '../../base/interceptors/auth-error-base.interceptor';
import { AuthTarget } from '../../base/models/auth-target.model';
import { ApiError } from '@cms_root/app/core/models/api-error.model';

@Injectable()
export class AuthErrorInterceptor extends AuthErrorInterceptorBase {
  constructor(private readonly authService: AuthService) {
    super();
  }

  protected handleUnauthorized(error: ApiError): void {
    this.authService.refreshSession(null, AuthTarget.totara);
  }
}
